<div class="side-nav-categories">
  <div class="block-title"> {{'common.categories' | translate}} </div>
  <div class="box-content box-category">
    <ul>
      <li [class.active]="activeSlug === 'all'">
        <a [routerLink]="['/products', 'category', 'all']">
          {{ 'common.all_products' | translate }}
        </a>
      </li>
      <li *ngFor="let category of categories" [class.active]="category.slug === activeSlug">
        <a [routerLink]="['/products', 'category', category.slug ]">
          {{ currentLanguage == 'en' ? category.name : ((category.nameFr != null && category.nameFr != '') ? category.nameFr : category.name) }}
        </a>
      </li>
    </ul>
  </div>
</div>
